import React from 'react';

import classNames from 'classnames';
import { CircularProgress } from '@buildoutinc/blueprint-react/ui/Progress';

type Props = {
  addBottomBuffer?: boolean;
  className?: string;
  flex?: boolean;
  inline?: boolean;
  loadingText?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  skipTopBuffer?: boolean;
};

export default function LoadingSpinner({
  addBottomBuffer,
  className,
  flex,
  inline,
  loadingText,
  size = 'xl',
  skipTopBuffer,
}: Props) {
  const spinnerClassNames = classNames(className, {
    'd-inline': inline,
    'd-flex': flex,
    'text-center': true,
    'mt-5': !skipTopBuffer && !inline,
    'mb-5': addBottomBuffer
  });

  return (
    <div className={spinnerClassNames}>
      <CircularProgress size={size} />
      {loadingText && <div className="mt-2 text-muted">{loadingText}</div>}
    </div>
  );
}
